/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

/**
 * The platform-managed inference key to update. Defaults to chat for compatibility.
 */
export const SetSpendCapRequestBodyKeyType = {
  Chat: "chat",
  Internal: "internal",
} as const;
/**
 * The platform-managed inference key to update. Defaults to chat for compatibility.
 */
export type SetSpendCapRequestBodyKeyType = ClosedEnum<
  typeof SetSpendCapRequestBodyKeyType
>;

export type SetSpendCapRequestBody = {
  /**
   * The platform-managed inference key to update. Defaults to chat for compatibility.
   */
  keyType?: SetSpendCapRequestBodyKeyType | undefined;
  /**
   * The monthly inference spend cap in USD
   */
  monthlyCredits: number;
};

/** @internal */
export const SetSpendCapRequestBodyKeyType$outboundSchema: z.ZodMiniEnum<
  typeof SetSpendCapRequestBodyKeyType
> = z.enum(SetSpendCapRequestBodyKeyType);

/** @internal */
export type SetSpendCapRequestBody$Outbound = {
  key_type?: string | undefined;
  monthly_credits: number;
};

/** @internal */
export const SetSpendCapRequestBody$outboundSchema: z.ZodMiniType<
  SetSpendCapRequestBody$Outbound,
  SetSpendCapRequestBody
> = z.pipe(
  z.object({
    keyType: z.optional(SetSpendCapRequestBodyKeyType$outboundSchema),
    monthlyCredits: z.int(),
  }),
  z.transform((v) => {
    return remap$(v, {
      keyType: "key_type",
      monthlyCredits: "monthly_credits",
    });
  }),
);

export function setSpendCapRequestBodyToJSON(
  setSpendCapRequestBody: SetSpendCapRequestBody,
): string {
  return JSON.stringify(
    SetSpendCapRequestBody$outboundSchema.parse(setSpendCapRequestBody),
  );
}
